
export const ActionTypes ={

    SET_VISA_CATEGORY:"SET_VISA_CATEGORY",
    SET_ARRIVAL_INFORMATION:"SET_ARRIVAL_INFORMATION",
    SET_PERSONAL_INFORMATION:"SET_PERSONAL_INFORMATION",
    SET_PASSPORT_INFORMATION:"SET_PASSPORT_INFORMATION",
    SET_SUPPORTING_DOCUMENT:"SET_SUPPORTING_DOCUMENT",
};